// Cómo se leen las sesiones abiertas · deuda T-c.
//
// VIVE AQUÍ Y NO EN LA PANTALLA para poder probarlo: describir un
// aparato a partir de la cadena del navegador es todo casos particulares,
// y un caso particular sin prueba es el que se rompe.

const FMT = new Intl.DateTimeFormat('es-MX', {
  day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit',
});

export function fechaYHora(v) {
  if (!v) return 'una fecha que no se registró';
  return FMT.format(new Date(v));
}

// EL APARATO, EN ESPAÑOL Y NO EN JERGA. «Chrome en Windows» lo reconoce
// cualquiera; «Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit…» no
// lo reconoce nadie — y esta pantalla existe justo para que alguien
// reconozca cuál sesión es la suya y cuál no.
//
// EL ORDEN DE LAS COMPROBACIONES NO ES CASUAL. Casi todos los
// navegadores dicen «Safari» y muchos dicen «Chrome», así que lo
// específico va primero: Edge dice Chrome y Safari, Chrome dice Safari.
const NAVEGADORES = [
  [/Edg\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/Firefox\//, 'Firefox'],
  [/Chrome\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

const SISTEMAS = [
  [/Android/, 'Android'],
  [/iPhone|iPad|iPod/, 'iPhone o iPad'],
  [/Windows/, 'Windows'],
  [/Mac OS X|Macintosh/, 'Mac'],
  [/Linux/, 'Linux'],
];

function primero(tabla, texto) {
  for (const [patron, nombre] of tabla) {
    if (patron.test(texto)) return nombre;
  }
  return null;
}

export function describirAparato(userAgent) {
  // NUNCA UN HUECO EN BLANCO: «no se registró» es una respuesta, un
  // espacio vacío es una pregunta.
  if (!userAgent) return 'Un aparato que no se identificó';

  const navegador = primero(NAVEGADORES, userAgent);
  const sistema = primero(SISTEMAS, userAgent);

  if (navegador && sistema) return `${navegador} en ${sistema}`;
  if (navegador) return navegador;
  if (sistema) return `Un navegador en ${sistema}`;
  // Se enseña un trozo en vez de nada: puede que quien lo lea lo
  // reconozca aunque nosotros no.
  return `Un aparato desconocido (${userAgent.slice(0, 40)})`;
}
